var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      class: _vm.iconClasses,
      style: _vm.iconStyles,
      attrs: {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.00627 1.39671C7.15484 1.3659 7.31184 1.46019 7.35487 1.60566L7.78519 3.06006C7.82852 3.20522 7.98728 3.33694 8.13793 3.3528L9.30786 3.57831C9.45374 3.61932 9.64976 3.5548 9.74336 3.43556L10.6795 2.23873C10.7731 2.11921 10.954 2.08932 11.0809 2.17252L12.2363 2.93076C12.3629 3.01396 12.4078 3.19064 12.3356 3.32384L11.6095 4.65928C11.5373 4.79257 11.5563 4.99783 11.6519 5.11546L12.3222 6.10024C12.3969 6.23205 12.5815 6.32539 12.7318 6.30712L14.2369 6.12299C14.3875 6.10466 14.536 6.21142 14.5669 6.35988L14.8472 7.71187C14.8777 7.86029 14.7836 8.01749 14.6383 8.06047L13.1839 8.49079C13.1086 8.51318 13.0369 8.56634 12.9832 8.63354L11.7305 7.91048C11.4518 6.05314 9.84951 4.62928 7.91449 4.62928C5.7834 4.62941 4.05623 6.3566 4.05609 8.48769C4.05609 10.4206 5.47677 12.0213 7.33108 12.3026V13.5833L6.22941 13.3712C6.08341 13.33 5.8875 13.3945 5.79392 13.514L4.85673 14.7108C4.76323 14.8297 4.58306 14.8599 4.45641 14.777L3.30199 14.0188C3.17557 13.9355 3.13161 13.7579 3.20372 13.6246L3.92885 12.2902C4.00126 12.157 3.98205 11.9508 3.88644 11.833L3.21613 10.8493C3.14156 10.7173 2.95796 10.6241 2.80754 10.6424L1.30245 10.8255C1.15213 10.8438 1.0037 10.7377 0.972467 10.5896L0.692138 9.23765C0.661368 9.08927 0.754904 8.93232 0.900057 8.88905L2.35446 8.45873C2.49978 8.41574 2.63216 8.25677 2.64824 8.10599L2.87271 6.93605C2.91375 6.79012 2.84929 6.59412 2.72995 6.50056L1.53313 5.5644C1.41386 5.4709 1.38508 5.28982 1.46796 5.16305L2.22516 4.00759C2.30836 3.88072 2.48594 3.83585 2.61927 3.90829L3.95368 4.63446C4.08684 4.7067 4.29317 4.68761 4.4109 4.59204L5.39463 3.92174C5.52664 3.84731 5.61963 3.66257 5.60152 3.51211L5.41843 2.00702C5.40017 1.85646 5.50688 1.7079 5.65531 1.67704L7.00627 1.39671Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M17.5001 12.3193L8.33649 17.6095V7.02916L17.5001 12.3193Z",
          fill: _vm.fillColor,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }